import URL from "./URL";

const PROP = {

  DEFINITELY_PAD: [
    'LG-X760W'
  ],

  MONTH: [
    { label: '1월', data: '01' },
    { label: '2월', data: '02' },
    { label: '3월', data: '03' },
    { label: '4월', data: '04' },
    { label: '5월', data: '05' },
    { label: '6월', data: '06' },
    { label: '7월', data: '07' },
    { label: '8월', data: '08' },
    { label: '9월', data: '09' },
    { label: '10월', data: '10' },
    { label: '11월', data: '11' },
    { label: '12월', data: '12' },
  ],

  YEAR: [
    { label: '2002년', data: '2002' },
    { label: '2003년', data: '2003' },
    { label: '2004년', data: '2004' },
    { label: '2005년', data: '2005' },
    { label: '2006년', data: '2006' },
    { label: '2007년', data: '2007' },
    { label: '2008년', data: '2008' },
    { label: '2009년', data: '2009' },
    { label: '2010년', data: '2010' },
    { label: '2011년', data: '2011' },
    { label: '2012년', data: '2012' },
    { label: '2013년', data: '2013' },
    { label: '2014년', data: '2014' },
    { label: '2015년', data: '2015' },
    { label: '2016년', data: '2016' },
    { label: '2017년', data: '2017' },
    { label: '2018년', data: '2018' },
    { label: '2019년', data: '2019' },
    { label: '2020년', data: '2020' },
    { label: '2021년', data: '2021' },
  ],

  CHANEN_CODE: {
    SMART_ALL: 'WJTB',
    GM: 'GM',
    GM_APP: 'GM_APP',
    MATH_PID: 'MATH_PID',
  },

  ASIDE_MEMU: {
    WJTB: {
      MAIN: [
        { title: '홈', path: URL.SELECT_LEARNING, },
        { title: '코스학습', path: URL.COURSE_LEARNING.LIST },
        { title: '주제학습', path: URL.TOPIC_LEARNING },
        { title: '제품소개', path: URL.INTRODUCTION },
      ],
      SUB: [],
    },
    GM: {
      MAIN: [
        { title: '홈', path: URL.SELECT_LEARNING },
        { title: '진도학습', path: URL.PROGRESS_LEARNING.I },
        { title: '주제학습', path: URL.TOPIC_LEARNING },
        { title: 'OCR학습', path: URL.OCR.I },
      ],
      SUB: [
        { title: 'AI 진단테스트', path: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA },
        { title: '학습노트', path: URL.COURSE_LEARNING.LEARNING_NOTE },
        { title: 'APP 계정 신청', path: URL.ACCOUNT.APP_ID_SIGN }
      ],
    },
    GM_APP: {
      MAIN: [
        { title: '홈', path: URL.SELECT_LEARNING },
        { title: '진도학습', path: URL.PROGRESS_LEARNING.I },
        { title: '주제학습', path: URL.TOPIC_LEARNING },
        { title: 'OCR학습', path: URL.OCR.I },
      ],
      SUB: [
        { title: 'AI 진단테스트', path: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA },
        { title: '학습노트', path: URL.COURSE_LEARNING.LEARNING_NOTE },
        { title: 'MY', path: URL.ACCOUNT.MY_PAGE },
      ],
    },
    CP: {
      MAIN: [
        { title: '홈', path: URL.SELECT_LEARNING },
        { title: '진도학습', path: URL.PROGRESS_LEARNING.I },
        { title: '주제학습', path: URL.TOPIC_LEARNING },
        { title: 'OCR학습', path: URL.OCR.I },
      ],
      SUB: [
        { title: 'AI 진단테스트', path: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA },
        { title: '학습노트', path: URL.COURSE_LEARNING.LEARNING_NOTE },
      ],
    },
    GLOBAL01: {
      MAIN: [
        { title: '홈', path: URL.SELECT_LEARNING, localeCode: 'menu.msg002' },
        { title: '코스학습', path: URL.COURSE_LEARNING.LIST, localeCode: 'menu.msg010' },
        { title: '주제학습', path: URL.TOPIC_LEARNING, localeCode: 'menu.msg004' },
        { title: '수학 카메라', path: URL.OCR.I, localeCode: 'menu.msg005' },
      ],
      SUB: [
        { title: '학습노트', path: URL.COURSE_LEARNING.LEARNING_NOTE, localeCode: 'menu.msg007' },
        { title: '마이페이지', path: URL.ACCOUNT.MY_PAGE, localeCode: 'menu.msg012' },
        { title: '고객지원', path: URL.HELP, localeCode: 'menu.msg009' },
        { title: '제품소개', path: URL.INTRODUCTION, localeCode: 'menu.msg011' },
      ]
    }
  },

  /**
   * 7세(학기구분 없음)-1학기: 수Ⅰ(A01_0_1) / 2학기: 수Ⅰ(A01_0_1)
   * 1학년-1학기: 덧셈(B02_0_1) / 2학기: 덧셈(B15_0_1)
   * 2학년-1학기: 덧셈(C15_0_1) / 2학기: 곱셈(E17_0_1)
   * 3학년-1학기: 덧셈(E04_0_1) / 2학기: 곱셈(E26_0_1)
   * 4학년-1학기: 나눗셈(F17_0_1) / 2학기: 분수(G05_0_1)
   * 5학년-1학기: 혼합계산(F23_0_1) / 2학기: 분수(H17_0_1)
   * 6학년-1학기: 분수(H20_0_1) / 2학기: 분수(H21_0_1)
   * 중1-1학기: 수Ⅱ(J02_0_1) / 2학기: 확률과 통계(J45_0_1)
   * 중2-1학기: 수Ⅱ(K02_0_1) / 2학기: 확률과 통계(K45_0_1)
   * 중3-1학기: 수Ⅱ(L02_0_1) / 2학기: 확률과 통계(L40_0_1)
   */
  STATE_CODE_BY_GRADE: {
    FIRST_SEMESTER: [
      { age: 7, thmaCd: 'THMA_00', stgCd: 'A01_0_1' },    // 유치원
      { age: 8, thmaCd: 'THMA_01', stgCd: 'B02_0_1' },    // 1학년
      { age: 9, thmaCd: 'THMA_01', stgCd: 'C15_0_1' },    // 2학년
      { age: 10, thmaCd: 'THMA_01', stgCd: 'E04_0_1' },   // 3학년
      { age: 11, thmaCd: 'THMA_04', stgCd: 'F17_0_1' },   // 4학년
      { age: 12, thmaCd: 'THMA_05', stgCd: 'F23_0_1' },   // 5학년
      { age: 13, thmaCd: 'THMA_06', stgCd: 'H20_0_1' },   // 6학년
      { age: 14, thmaCd: 'THMA_11', stgCd: 'J02_0_1' },   // 중1
      { age: 15, thmaCd: 'THMA_11', stgCd: 'K02_0_1' },   // 중2
      { age: 16, thmaCd: 'THMA_11', stgCd: 'L02_0_1' },   // 중3
      // { age: 17, thmaCd: '', stgCd: '' },
      // { age: 18, thmaCd: '', stgCd: '' },
      // { age: 19, thmaCd: '', stgCd: '' },
    ],
    SECOND_SEMESTER: [
      { age: 7, thmaCd: 'THMA_00', stgCd: 'A01_0_1' },    // 유치원
      { age: 8, thmaCd: 'THMA_01', stgCd: 'B15_0_1' },    // 1학년
      { age: 9, thmaCd: 'THMA_03', stgCd: 'E17_0_1' },    // 2학년
      { age: 10, thmaCd: 'THMA_03', stgCd: 'E26_0_1' },   // 3학년
      { age: 11, thmaCd: 'THMA_06', stgCd: 'G05_0_1' },   // 4학년
      { age: 12, thmaCd: 'THMA_06', stgCd: 'H17_0_1' },   // 5학년
      { age: 13, thmaCd: 'THMA_06', stgCd: 'H21_0_1' },   // 6학년
      { age: 14, thmaCd: 'THMA_15', stgCd: 'J45_0_1' },   // 중1
      { age: 15, thmaCd: 'THMA_15', stgCd: 'K45_0_1' },   // 중2
      { age: 16, thmaCd: 'THMA_15', stgCd: 'L40_0_1' },   // 중3
      // { age: 17, thmaCd: '', stgCd: '' },
      // { age: 18, thmaCd: '', stgCd: '' },
      // { age: 19, thmaCd: '', stgCd: '' },
    ],
  },

  SIDE_ICON: [
    "static/images/icon/ic_account_01.svg",
    "static/images/icon/ic_account_02.svg",
    "static/images/icon/ic_account_03.svg",
    "static/images/icon/ic_account_04.svg",
    "static/images/icon/ic_account_05.svg",
  ],

  THMA_NM_GB_CODE: [
    { name: "수Ⅰ", code: 'msg002' },
    { name: "덧셈", code: 'msg003' },
    { name: "뺄셈", code: 'msg004' },
    { name: "곱셈", code: 'msg005' },
    { name: "나눗셈", code: 'msg006' },
    { name: "혼합계산", code: 'msg007' },
    { name: "분수", code: 'msg008' },
    { name: "소수", code: 'msg009' },
    { name: "방정식", code: 'msg010' },
    { name: "비례식", code: 'msg011' },
    { name: "수Ⅱ", code: 'msg020' },
    { name: "연산", code: 'msg012' },
    { name: "문자와식", code: 'msg013' },
    { name: "함수", code: 'msg014' },
    { name: "확률과통계", code: 'msg015' },
  ],

  CHART_XY: [
    { 'x': 0.2, 'y': 0.00013383 },
    { 'x': 0.3, 'y': 0.000198656 },
    { 'x': 0.4, 'y': 0.000291947 },
    { 'x': 0.5, 'y': 0.00042478 },
    { 'x': 0.6, 'y': 0.000611902 },
    { 'x': 0.7, 'y': 0.000872683 },
    { 'x': 0.8, 'y': 0.001232219 },
    { 'x': 0.9, 'y': 0.001722569 },
    { 'x': 1, 'y': 0.002384088 },
    { 'x': 1.1, 'y': 0.003266819 },
    { 'x': 1.2, 'y': 0.004431848 },
    { 'x': 1.3, 'y': 0.005952532 },
    { 'x': 1.4, 'y': 0.007915452 },
    { 'x': 1.5, 'y': 0.010420935 },
    { 'x': 1.6, 'y': 0.013582969 },
    { 'x': 1.7, 'y': 0.017528301 },
    { 'x': 1.8, 'y': 0.02239453 },
    { 'x': 1.9, 'y': 0.028327038 },
    { 'x': 2, 'y': 0.035474593 },
    { 'x': 2.1, 'y': 0.043983596 },
    { 'x': 2.2, 'y': 0.053990967 },
    { 'x': 2.3, 'y': 0.065615815 },
    { 'x': 2.4, 'y': 0.078950158 },
    { 'x': 2.5, 'y': 0.094049077 },
    { 'x': 2.6, 'y': 0.110920835 },
    { 'x': 2.7, 'y': 0.129517596 },
    { 'x': 2.8, 'y': 0.149727466 },
    { 'x': 2.9, 'y': 0.171368592 },
    { 'x': 3, 'y': 0.194186055 },
    { 'x': 3.1, 'y': 0.217852177 },
    { 'x': 3.2, 'y': 0.241970725 },
    { 'x': 3.3, 'y': 0.26608525 },
    { 'x': 3.4, 'y': 0.289691553 },
    { 'x': 3.5, 'y': 0.312253933 },
    { 'x': 3.6, 'y': 0.333224603 },
    { 'x': 3.7, 'y': 0.352065327 },
    { 'x': 3.8, 'y': 0.36827014 },
    { 'x': 3.9, 'y': 0.381387816 },
    { 'x': 4, 'y': 0.391042694 },
    { 'x': 4.1, 'y': 0.396952548 },
    { 'x': 4.2, 'y': 0.39894228 },
    { 'x': 4.3, 'y': 0.396952548 },
    { 'x': 4.4, 'y': 0.391042694 },
    { 'x': 4.5, 'y': 0.381387816 },
    { 'x': 4.6, 'y': 0.36827014 },
    { 'x': 4.7, 'y': 0.352065327 },
    { 'x': 4.8, 'y': 0.333224603 },
    { 'x': 4.9, 'y': 0.312253933 },
    { 'x': 5, 'y': 0.289691553 },
    { 'x': 5.1, 'y': 0.26608525 },
    { 'x': 5.2, 'y': 0.241970725 },
    { 'x': 5.3, 'y': 0.217852177 },
    { 'x': 5.4, 'y': 0.194186055 },
    { 'x': 5.5, 'y': 0.171368592 },
    { 'x': 5.6, 'y': 0.149727466 },
    { 'x': 5.7, 'y': 0.129517596 },
    { 'x': 5.8, 'y': 0.110920835 },
    { 'x': 5.9, 'y': 0.094049077 },
    { 'x': 6, 'y': 0.078950158 },
    { 'x': 6.1, 'y': 0.065615815 },
    { 'x': 6.2, 'y': 0.053990967 },
    { 'x': 6.3, 'y': 0.043983596 },
    { 'x': 6.4, 'y': 0.035474593 },
    { 'x': 6.5, 'y': 0.028327038 },
    { 'x': 6.6, 'y': 0.02239453 },
    { 'x': 6.7, 'y': 0.017528301 },
    { 'x': 6.8, 'y': 0.013582969 },
    { 'x': 6.9, 'y': 0.010420935 },
    { 'x': 7, 'y': 0.007915452 },
    { 'x': 7.1, 'y': 0.005952532 },
    { 'x': 7.2, 'y': 0.004431848 },
    { 'x': 7.3, 'y': 0.003266819 },
    { 'x': 7.4, 'y': 0.002384088 },
    { 'x': 7.5, 'y': 0.001722569 },
    { 'x': 7.6, 'y': 0.001232219 },
    { 'x': 7.7, 'y': 0.000872683 },
    { 'x': 7.8, 'y': 0.000611902 },
    { 'x': 7.9, 'y': 0.00042478 },
    { 'x': 8, 'y': 0.000291947 },
    { 'x': 8.1, 'y': 0.000198656 },
    { 'x': 8.2, 'y': 0.00013383 },
  ],

  ANSWERING_QUESTIONS_TUTORIAL_VERSION: 'v.4.0.1',

  ANSWERING_TEST_DATA : {
    "rgtnDt": null,
    "rgtnUser": null,
    "modDt": null,
    "modUser": null,
    "lrnMbrId": null,
    "aiPrdcnQstCt": 10,
    "estQstNowNo": 0,
    "estDiagDur": 1,
    "estQstDurMax": 300000,
    "estQstDurMin": 1623,
    "stgCd": "B02_0_1",
    "stgNm": "한 자리 수 덧셈(1)",
    "qstCd": "B02010015",
    "fontSize": "100;100;100;100",
    "textCn": "다음 덧셈을 하세요.",
    "qstCn": "1 + 7 = \\boxed{\\cssId{inputArea0}{8}}",
    "exmpCn": null,
    "langCd": null,
    "qstCransr": "8",
    "cransrTyScnCd": "CTS02",
    // "objctExmpCn": "7;6;5",
    // "objctYn": "Y",
    "objctExmpCn": "(0,~0),~y=0;(0,~2),~x=0;(0,~2),~y=0",
    "objctYn": "Y",
    "cncpMeta": "https://s3.ap-northeast-2.amazonaws.com/wjtb-dev-pub/brs/mov/cncp/ko/B02_0_1_3.json",
    "cncpMetaFilePath": null,
    "cncpMetaFileNm": null,
    "kypdTyCd": "KP01",
    "lrnEntyScnCd": null,
    "corPsbleQstYn": "N",
    "prgsCd": "W",
    "prgsMsgYn": null,
    "hstMsgYn": "Y",
    "hstYn": "Y",
    "inputTy": null,
    "overTmYn": null,
    "movieSkipYn": null,
    "movieTm": null,
    "lrnTotScond": 0,
    "slvTime": 0,
    "inptTime": 0,
    "drilldwCt": 0,
    "drilldwStgCd": null,
    "drilldwDepth": 0,
    "drilldwQstCt": 0,
    "explSpedCd": null,
    "explSped": 0,
    "rcmnSbthmaCd": null,
    "lrnBgnDt": null,
    "lrnEndDt": null,
    "cransrQstCt": 0,
    "wransrQstCt": 0,
    "drilldwCransrQstCt": 0,
    "drilldwWransrQstCt": 0,
    "lrnPrgsStsCd": null,
    "explAcrcyCd": null,
    "explAcrcyRt": 89,
    "lrnTmeSn": 0,
    "dspSitutCd": null,
    "msgeSn": 0,
    "aiMsge": null,
    "totQstCt": 10,
    "entyPathCd": null,
    "cransrRt": 0.0,
    "chnCd": null,
    "stepNm": "받아올림이 없는 한 자리 수 덧셈",
    "thmaNm": "덧셈"
  }

};

export default PROP;
